<!-- 
  -- Projet: Gestion des stagiaires
  -- Auteur : Tim Allemann
  -- Date : 16.09.2020
  -- Description : Formulaire de création d'une TypeJobSearchAssistance depuis la liste des TypeJobSearchAssistances
  -- Fichier : CreateTypeJobSearchAssistanceFromList.vue
  -->

<template>
  <v-row>
    <v-form
      ref="formCreateTypeJobSearchAssistance"
      v-model="validCreateTypeJobSearchAssistance"
      lazy-validation
    >
      <v-dialog v-model="dialog" max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" class="mx-3" color="primary">
            Ajouter un type ARE
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Ajouter un type ARE</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              v-model="typeJobSearchAssistance.description"
              label="Nom"
              required
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">
              Fermer
            </v-btn>
            <v-btn color="blue darken-1" text @click="submit()">
              Sauvegarder
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-form>
  </v-row>
</template>

<script>
import store from '@/store/index.js'
import NProgress from 'nprogress'

export default {
  data: () => ({
    validCreateTypeJobSearchAssistance: true,
    dialog: false,
    typeJobSearchAssistance: {
      typeJobSearchAssistanceId: 0,
      description: null
    },
    descriptionRules: [v => !!v || 'Le champ est obligatoire']
  }),

  methods: {
    // Si le formulaire est valide, création d'une TypeJobSearchAssistance
    submit() {
      if (this.$refs.formCreateTypeJobSearchAssistance.validate()) {
        NProgress.start()
        store
          .dispatch(
            'typeJobSearchAssistance/createTypeJobSearchAssistance',
            this.typeJobSearchAssistance
          )
          .then(() => {
            this.$refs.formCreateTypeJobSearchAssistance.reset()
            this.dialog = false
          })
          .catch(() => {})

        NProgress.done()
      }
    }
  }
}
</script>
